// frontend/src/askos/liveSessions/LiveSessionsPage.js
//
// Student's own Live Sessions library: upcoming / ongoing / completed tabs.
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listLiveSessionsStudent, getMyAttendance } from '../../api/liveSessionsApi';

const TABS = [
    { key: 'scheduled', label: 'Upcoming' },
    { key: 'live', label: 'Ongoing' },
    { key: 'completed', label: 'Library (Completed)' },
];

const LiveSessionsPage = ({ slug }) => {
    const [activeTab, setActiveTab] = useState('scheduled');
    const [sessions, setSessions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [myAttendance, setMyAttendance] = useState(null);
    const [showAttendanceDetail, setShowAttendanceDetail] = useState(false);
    const navigate = useNavigate();

    const load = useCallback(() => {
        setLoading(true);
        listLiveSessionsStudent(slug, activeTab)
            .then(setSessions)
            .catch(() => setSessions([]))
            .finally(() => setLoading(false));
    }, [slug, activeTab]);

    useEffect(() => {
        load();
        const interval = setInterval(load, 20000);
        return () => clearInterval(interval);
    }, [load]);

    useEffect(() => {
        getMyAttendance(slug).then(setMyAttendance).catch(() => setMyAttendance(null));
    }, [slug]);

    return (
        <div className="subpage">
            <h2>Live Sessions</h2>

            {myAttendance && (
                <div style={{ marginBottom: 16 }}>
                    <p className="empty-note" style={{ marginBottom: showAttendanceDetail ? 8 : 0 }}>
                        {myAttendance.sessions_attended > 0 ? (
                            <>
                                You've attended <strong>{myAttendance.sessions_attended}</strong> session{myAttendance.sessions_attended === 1 ? '' : 's'},{' '}
                                <strong>{Math.round(myAttendance.total_minutes)}</strong> minutes total.{' '}
                                <a href="#" onClick={e => { e.preventDefault(); setShowAttendanceDetail(o => !o); }}>
                                    {showAttendanceDetail ? 'Hide' : 'Show'} sessions
                                </a>
                            </>
                        ) : (
                            "You haven't attended any live sessions yet."
                        )}
                    </p>
                    {showAttendanceDetail && myAttendance.sessions.length > 0 && (
                        <ul style={{ paddingLeft: 20, margin: 0 }}>
                            {myAttendance.sessions.map(s => (
                                <li key={s.session_id} className="empty-note">
                                    <strong>{s.topic}</strong> — {new Date(s.scheduled_start_utc).toLocaleDateString()} · {Math.round(s.minutes_attended)} min
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}

            <div className="d-flex gap-2 mb-3">
                {TABS.map(t => (
                    <button
                        key={t.key}
                        type="button"
                        className={activeTab === t.key ? 'primary-btn' : 'secondary-btn'}
                        onClick={() => setActiveTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {loading && <p className="empty-note">Loading…</p>}
            {!loading && sessions.length === 0 && <p className="empty-note">Nothing here yet.</p>}

            <div className="grid two-col">
                {sessions.map(s => (
                    <article key={s.id} className="panel">
                        <div className="panel-heading">
                            <h3>{s.topic}</h3>
                        </div>
                        <p>{s.faculty_name} {s.faculty_designation ? `— ${s.faculty_designation}` : ''}</p>
                        <p className="empty-note">{s.subject_label}</p>
                        <p>{new Date(s.scheduled_start_utc).toLocaleString()} · {s.duration_minutes} min</p>
                        {s.status === 'live' && (
                            <button type="button" className="primary-btn" onClick={() => navigate(`/samkalp-ias/live/${s.id}`)}>Join Now</button>
                        )}
                        {s.status === 'completed' && (
                            <button type="button" className="secondary-btn" onClick={() => navigate(`/samkalp-ias/live/${s.id}`)}>View / Recording</button>
                        )}
                        {s.status === 'scheduled' && (
                            <p className="empty-note">Join button appears 10 minutes before start.</p>
                        )}
                    </article>
                ))}
            </div>
        </div>
    );
};

export default LiveSessionsPage;
